<script>
	import { updateDoc, doc, getFirestore } from "firebase/firestore";
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

	import { store } from "$lib/utilities/store";

	export let collection;
	export let postUpdateFunction = () => {};
	export let updateProfile = true;

	let timeoutId;
	let previousValue;
	$: (() => {
		if (!updateProfile) {
			postUpdateFunction();
			return;
		}
		if (
			$store.userProfile?.collectionCriteria?.[collection]?.search ===
			previousValue
		)
			return;
		if (previousValue === undefined) {
			previousValue =
				$store.userProfile.collectionCriteria?.[collection]?.search;
			return;
		}
		previousValue =
			$store.userProfile.collectionCriteria?.[collection]?.search;

		if (timeoutId !== undefined) {
			clearTimeout(timeoutId);
		}

		timeoutId = setTimeout(async () => {
			console.log(`updating userProfile ${collection} search`);
			await updateDoc(
				doc(getFirestore(), `profiles/${$store.userProfile.uid}`),
				{
					collectionCriteria: {
						...$store.userProfile.collectionCriteria,
						[collection]:
							$store.userProfile.collectionCriteria[collection],
					},
				},
			);

			postUpdateFunction();
		}, 1000);
	})();

	const handleSearchClear = () => {
		$store.userProfile.collectionCriteria[collection].search = "";
	};
</script>

<div class="p-2 bg-base-300">
	<div class="flex">
		{#if $store.userProfile?.collectionCriteria?.[collection]}
			<input
				name={`${collection}Search-input`}
				data-hotkey="s,/"
				aria-label="Search"
				id={`${collection}Search-input`}
				type="text"
				bind:value={
					$store.userProfile.collectionCriteria[collection].search
				}
				class="w-48 input input-bordered input-primary sm:w-72"
				placeholder="Search…"
				autocorrect="off"
				autocomplete="off"
				autocapitalize="off"
			/>
		{/if}
		<div class="my-auto ml-2 sm:ml-4">
			<button
				class="my-auto mt-[6px]"
				on:click|preventDefault={handleSearchClear}
			>
				<SvelteFa icon={faCircleXmark} size="1.5x" />
			</button>
		</div>
	</div>
</div>
